import { submitGamificationHeartbeat } from '@/services/home/gamification';
import React, { useEffect, useRef } from 'react';

type GamificationHeartbeatProps = {
  enabled?: boolean;
};

const HEARTBEAT_SECONDS = 60;
const ACTIVE_WINDOW_MS = 10 * 60 * 1000;

const GamificationHeartbeat: React.FC<GamificationHeartbeatProps> = ({ enabled }) => {
  const lastActivityRef = useRef(0);

  useEffect(() => {
    if (!enabled) return undefined;

    const markActive = () => {
      lastActivityRef.current = Date.now();
    };
    const activityEvents: Array<keyof WindowEventMap> = [
      'mousemove',
      'keydown',
      'pointerdown',
      'touchstart',
      'scroll',
    ];
    activityEvents.forEach((eventName) =>
      window.addEventListener(eventName, markActive, { passive: true }),
    );

    const timer = window.setInterval(() => {
      const recentlyActive =
        lastActivityRef.current > 0 && Date.now() - lastActivityRef.current <= ACTIVE_WINDOW_MS;
      if (document.visibilityState !== 'visible' || !recentlyActive) {
        return;
      }
      submitGamificationHeartbeat(HEARTBEAT_SECONDS, { skipErrorHandler: true }).catch(() => {
        // ポイント加算の失敗は画面操作を妨げないため、ここでは握りつぶします。
      });
    }, HEARTBEAT_SECONDS * 1000);

    return () => {
      window.clearInterval(timer);
      activityEvents.forEach((eventName) => window.removeEventListener(eventName, markActive));
    };
  }, [enabled]);

  return null;
};

export default GamificationHeartbeat;
